import { ref } from "vue";

export const addItemModalIsOpen = ref(false);
